import { useTranslation } from "shared/i18n/useTranslation";
import { Photo } from "api/types/photo";
import { UploadImageButton } from "components/uploadButton";
import { PhotoType } from "api/types/photoType";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export interface PhotoPreviewUploadType {
  photo?: Photo;
  photoType: PhotoType;
  onChange: (photo: Photo) => void;
  onDelete: (photo: Photo) => void;
}
export const emptyPhoto: Photo = {
  id: null,
  originalPath: null,
  temporaryPath: null,
  thumbnailPath: null,
  typeId: null,
};
export function PhotoPreviewUpload({
  photo = emptyPhoto,
  photoType,
  onChange,
  onDelete,
}: PhotoPreviewUploadType) {
  const { translate } = useTranslation();
  function handleFileUpload(filepath) {
    const newPhoto: Photo = {
      ...photo,
      typeId: photoType.id,
      temporaryPath: filepath,
    };
    onChange(newPhoto);
  }

  function handleDelete(photo: Photo) {
    onDelete(photo);
  }

  return (
    <div className="d-flex flex-column pt-2">
      {photo.temporaryPath ? (
        <div className="img-thumbnail text-center form-text">
          {translate("__previewWillBeAvailableAfterYouSave")}
        </div>
      ) : (
        <>
          {photo.thumbnailPath && (
            <div className="d-flex align-items-center justify-content-center ">
              <div className=" ">
                <a
                  className="text-center"
                  href={photo.originalPath ?? photo.thumbnailPath}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={photo.thumbnailPath}
                    className="img-thumbnail"
                    alt={photoType.text ?? ""}
                    style={{ objectFit: "contain", height: "10rem" }}
                  />
                </a>
              </div>
              <div>
                <button
                  className="btn btn-sm btn-outline-primary ms-2"
                  onClick={() => handleDelete(photo)}
                >
                  <FontAwesomeIcon icon={faTrashCan} />
                </button>
              </div>
            </div>
          )}
        </>
      )}

      <UploadImageButton
        labelClassName="mt-2"
        onFileUpload={handleFileUpload}
      />
    </div>
  );
}
